import { GetMessageResponse } from '@schooly/api';
import React, { FC } from 'react';

import { useMessageRecipientsDerivation } from '../../useMessageRecipientsDerivation';
import { MessagesModalPreviewSendToView } from './MessagesModalPreviewSendToView';

export const MessageRecipientsPreviewFromApi: FC<{ data: GetMessageResponse }> = ({ data }) => {
  const {
    staff,
    staffCriteria,
    staffByIndividualStudent,
    parents,
    parentsCriteria,
    parentsByIndividualStudent,
    criteriaDate,
  } = useMessageRecipientsDerivation(data);

  return (
    <MessagesModalPreviewSendToView
      staff={staff}
      staffCriteria={staffCriteria}
      staffByIndividualStudent={staffByIndividualStudent}
      parents={parents}
      parentsCriteria={parentsCriteria}
      parentsByIndividualStudent={parentsByIndividualStudent}
      criteriaDate={criteriaDate}
    />
  );
};
